import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "../firebase.config";

export const getInvoicesList = async (invoiceType = null) => {
  try {
    let q;
    if (invoiceType) {
      q = query(
        collection(db, "invoices"),
        where("invoiceType", "==", invoiceType)
      );
    } else {
      q = query(collection(db, "invoices"));
    }

    const querySnapshot = await getDocs(q);
    const invoices = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return invoices;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    return [];
  }
};

export const deleteInvoice = async (invoiceId) => {
  try {
    await deleteDoc(doc(db, "invoices", invoiceId));
    return true;
  } catch (e) {
    console.error("Error deleting invoice:", e);
    return false;
  }
};

export const getInvoiceById = async (invoiceId) => {
  try {
    const docRef = doc(db, "invoices", invoiceId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      console.warn(`Invoice with ID ${invoiceId} not found.`);
      return null;
    }
  } catch (error) {
    console.error("Error getting invoice:", error);
    return null;
  }
};
